import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ClerkProvider } from '@clerk/clerk-react';
import { initAnalytics, trackEvent } from './utils/analytics';

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Publishable Key')
}
 

// Load GA before render so the first pageview from App.js has gtag available.
// No-ops off production — see src/utils/analytics.js.
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
    <App />
    </ClerkProvider>
  </React.StrictMode>
);

// Core Web Vitals -> GA4. This was previously called with no argument, which
// made reportWebVitals short-circuit and the web-vitals dependency dead code.
// GA4 expects an integer `value`; CLS is a small fraction, so scale it.
reportWebVitals(({ name, delta, value, id }) => {
  trackEvent(name, {
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    metric_id: id,
    metric_value: value,
    metric_delta: delta,
  });
});
